import {createBrowserRouter} from 'react-router-dom';

import {lazy} from './components/lazy-loader';

const router = createBrowserRouter([
  {
    path: `*`,
    /** dynamically import the app component here to avoid initializing code that relies on the current URL */
    element: lazy(() => import(`./app`)),
  },
]);

export const getAppRouter = () => router;
